import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BaseListagem from "components/BaseListagem";
import Pessoa from "model/administracao/cadastro/Pessoa";
import Produto from "model/administracao/cadastro/produto/Produto";
import ItemEmprestimo from "model/patrimonio/ItemEmprestimo";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Column, ColumnFilterElementTemplateOptions } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import ItemEmprestimoService from "service/patrimonio/ItemEmprestimoService";
import { converterDataHora } from "utils/convert";
import { dateFilterTemplate, DateMatchModeOptions, filterApplyTemplate, IdMatchModeOptions, ListMatchModeOptions, ProdutoFilterTemplate, statusFilterTemplate, TextMatchModeOptions } from "utils/filterUtils";

const itemEmprestimoService = new ItemEmprestimoService();

export default function  ItemEmprestimoListagem() {
    const [pessoas, setPessoas] = useState<Pessoa[]>([]);
    const [produtos, setProdutos] = useState<Produto[]>([]);

    const navigate = useNavigate();

    useEffect(() => {
        itemEmprestimoService.pessoas().then(lista => {
            setPessoas(lista);
        }).catch(err => {
            console.log(err)
        });
        itemEmprestimoService.produtos().then(lista => {
            setProdutos(lista);
        }).catch(err => {
            console.log(err);
        });
    },[]);
    
    const defaultFilters: DataTableFilterMeta = {
        pessoaEmprestada: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS
                }
            ],
            operator: FilterOperator.AND
        },
        status: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.IN,
                }
            ],
            operator: FilterOperator.AND
        },
        dataEmprestimo: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        dataDevolucao: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        patrimonio: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        produto: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        }   
    }

    const editar = (id: number) => {
        let url = `/emprestimoPatrimonio/editar/${id}`;
        navigate(`${url}`);
    }

    const pessoaFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <Dropdown value={options.value} options={pessoas} 
            onChange={(e) => options.filterCallback(e.value)} 
            optionLabel="nome" optionValue="id" placeholder="Qualquer" className="p-column-filter" />
    }

    return (
        <BaseListagem ordenacao="id,DESC" 
            service={itemEmprestimoService} 
            urlService="/itemEmprestimo" 
            showEditButton={false}
            showRemoveButton={false}
            showNewButton={false}
            tituloPagina={'Itens de Emprestimos'} 
            defaultFilters={defaultFilters} showClearFilterButton nome="itemEmprestimo"
        >
            <Column field="emprestimoPatrimonio.pessoaEmprestada.nome" header="Pessoa Emprestada" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="pessoaEmprestada"
                filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement = {pessoaFilterTemplate}
                headerStyle={{ width: "15%" }} />
            <Column field="patrimonio.codigo" header="Patrimonio" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="patrimonio"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate}
                headerStyle={{ width: "15%" }} />
            <Column  
                header="Produto" 
                filter 
                showFilterOperator={false} 
                showAddButton={false} 
                filterPlaceholder="Escreva o filtro" 
                filterField="produto"
                filterMatchModeOptions={IdMatchModeOptions} 
                filterApply={filterApplyTemplate} 
                filterElement={(options) => <ProdutoFilterTemplate options={options} opcoes={produtos} />}
                body={(rowData) => rowData.itemProduto ? rowData.produto?.nome : rowData.patrimonio?.produto?.nome}
            />
            <Column field="dataEmprestimo" body={(rowData) => rowData.dataEmprestimo ? converterDataHora(rowData.dataEmprestimo) : ""} header="Data Emprestimo" style={{ width: '10em' }}
                filter showFilterOperator={false} showAddButton={false}
                filterMatchModeOptions={DateMatchModeOptions}
                filterApply={filterApplyTemplate} filterElement={dateFilterTemplate} filterMenuStyle={{ zIndex: 50 }} />
            <Column field="dataDevolucao" body={(rowData) => rowData.dataDevolucao ? converterDataHora(rowData.dataDevolucao) : ""} header="Data Devolução" style={{ width: '10em' }}
                filter showFilterOperator={false} showAddButton={false}
                filterMatchModeOptions={DateMatchModeOptions}
                filterApply={filterApplyTemplate} filterElement={dateFilterTemplate} filterMenuStyle={{ zIndex: 50 }} />
            <Column field="status" header="Status" body={(rowData)=>itemEmprestimoService.getStatus(rowData.status)} filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={ListMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => statusFilterTemplate(options, itemEmprestimoService.getListaStatusFilter())}
                headerStyle={{ width: "15%" }} />
            <Column field="inutilizavel" header="Inutilizavel?" style={{ width: '5em', textAlign: "center" }} body={(rowData)=><Checkbox checked={rowData.inutilizavel} />} />
            <Column key="colOpcoes" style={{ whiteSpace: 'nowrap', width: '7em' }} body={(rowData) => 
                <div>
                    <Button type="button" icon={<FontAwesomeIcon icon="edit" />} className="ui-button-info" onClick={() => editar(rowData.emprestimoPatrimonio.id)}></Button>
                </div>}
            />
        </BaseListagem>
    )
}